export default (array, func) => array.reduce((accumulator, obj) => ({ ...accumulator, ...func(obj) }), {});
